import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Hero from "../components/Retail/Hero";
import IndustriesContent from "../components/Retail/IndustriesContent";
import PageTitle from "../components/Retail/PageTitle";

import '../assets/Webdevelopment.css';



const Retail = () => {
	return(
		<div className="App">
			<PageTitle />
	    	<Hero />
	    	<IndustriesContent />
	  	</div>
	)
}

export default Retail;
